// valida si dos arreglos son iguales
export default function EqualArray(PrevArray, NextArray){
    let bandera = true;
    try {
        if(PrevArray.length === NextArray.length){
            Object.getOwnPropertyNames(PrevArray).forEach(
                function(p) {
                    if(bandera){
                        Object.getOwnPropertyNames(NextArray).forEach(
                            function(n) {
                                if(bandera){
                                    // console.log(p + ' -> ' + PrevArray[p] + '===' + NextArray[p]);
                                    if(PrevArray[p] !== NextArray[p]){
                                        bandera = false;
                                    }
                                }
                            }
                        )
                    }
                }
            )
        } else {
            bandera =  false;
        }
    } catch (error) {
        console.error("equalarray", error);
        // expected output: ReferenceError: nonExistentFunction is not defined
        // Note - error messages will vary depending on browser 
    }
    return bandera;
}